import { mapActions, mapGetters } from "vuex";
import { listGroups } from "@/common/services/search";
import { AD_LAYOUT_STUBS } from "@/common/consts";
const Advertising = () =>
	import(
		/* webpackChunkName: "component-advertising" */ "@/components/advertising"
	);
import Header from "@/components/header";
const Footer = () =>
	import(/* webpackChunkName: "component-footer" */ "@/components/footer");
const BackToTop = () =>
	import(
		/* webpackChunkName: "component-back-to-top" */ "@/components/back-to-top"
	);
import { created, mounted } from "./hooks";

export default {
	name: "App",
	components: {
		Advertising,
		Header,
		Footer,
		BackToTop,
	},
	computed: {
		...mapGetters(["isDialogOpen"]),
		groups() {
			return listGroups();
		},
		adLayoutStub() {
			if (!this.isSmallDevice) {
				return AD_LAYOUT_STUBS.TOP_LEADERBOARD;
			}

			return AD_LAYOUT_STUBS.ADHESION;
		},
	},
	data() {
		return {
			windowHeight: 0,
			windowWidth: 0,
		};
	},
	methods: {
		...mapActions(["updateNumberOfLevels"]),
		onWindowResize() {
			this.windowHeight =
				window.innerHeight ||
				document.documentElement.clientHeight ||
				document.body.clientHeight;
			this.windowWidth =
				window.innerWidth ||
				document.documentElement.clientWidth ||
				document.body.clientWidth;
			this.$store.commit("updateWindowProperties", {
				windowHeight: this.windowHeight,
				windowWidth: this.windowWidth,
			});
		},
		onWindowScroll() {
			this.$store.commit("updateWindowProperties", {
				scrollY: window.pageYOffset,
			});
		},
		detectWebPSupport() {
			const alpha =
				"UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==";
			const img = new Image();
			img.onload = () => {
				const result = img.width > 0 && img.height > 0;
				if (!result) {
					this.$el.classList.add("no-webp");
				}
			};

			img.onerror = () => {
				this.$el.classList.add("no-webp");
			};

			img.src = `data:image/webp;base64,${alpha}`;
		},
	},
	created,
	mounted,
};
